import { createInertiaApp } from "@inertiajs/svelte";
import { mount } from "svelte";
import "../css/application.css";

// Svelte 5 + Inertia v2 setup pattern
// ref: https://sveltethemes.dev/jmrecodes/svelte5-inertia-patterns-markdown
// - resolve: return module object (NOT .default) — Inertia extracts .default internally
// - setup: clear el.innerHTML before mount() to avoid hydration mismatch
createInertiaApp({
  resolve: (name: string) => {
    const pages = import.meta.glob("../pages/**/*.svelte", { eager: true }) as Record<string, any>;
    const page = pages[`../pages/${name}.svelte`];
    if (!page) {
      throw new Error(`Unknown page: ${name}`);
    }
    return page;
  },
  setup({ el, App, props }) {
    const target = el ?? document.body;
    target.innerHTML = "";
    mount(App, { target, props });
  },
});
